var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProteinOptimization = function SvgProteinOptimization(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4563 29.965C45.4704 27.3396 44.1642 24.3892 41.5388 23.3751C38.9135 22.361 35.9631 23.6672 34.949 26.2926L30.5426 37.7001C29.5285 40.3255 30.8347 43.2759 33.4601 44.29C36.0854 45.3041 39.0358 43.9979 40.05 41.3725L44.4563 29.965Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.967 23.429C33.4928 23.429 36.351 20.5708 36.351 17.045C36.351 13.5192 33.4928 10.661 29.967 10.661C26.4412 10.661 23.583 13.5192 23.583 17.045C23.583 20.5708 26.4412 23.429 29.967 23.429Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.855 30.464C18.4838 30.464 20.615 28.3329 20.615 25.704C20.615 23.0751 18.4838 20.944 15.855 20.944C13.2261 20.944 11.095 23.0751 11.095 25.704C11.095 28.3329 13.2261 30.464 15.855 30.464Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 41.356C24.3217 41.356 26.4529 39.2249 26.4529 36.596C26.4529 33.9671 24.3217 31.836 21.6929 31.836C19.064 31.836 16.9329 33.9671 16.9329 36.596C16.9329 39.2249 19.064 41.356 21.6929 41.356Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.544 32.347C19.068 31.528 18.592 30.709 18.116 29.897",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69399 33.25L4.33299 30.303L1.38599 34.664",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3059 22.862L51.6669 25.809L54.6139 21.448",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.611 30.499C50.337 42.511 40.089 51.73 28.014 51.73C15.939 51.73 5.66299 42.427 4.41699 30.499",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41699 25.501C5.69099 13.489 15.939 4.27 28.014 4.27C40.089 4.27 50.365 13.573 51.611 25.501",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProteinOptimization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/protein-optimization.b686ae6f.svg";
export { ForwardRef as ReactComponent };